import { crops } from '../../../data/config';
import { canClaimStarterSeedRelief } from '../../economy/domain/economyRules';
import { useGameStore } from '../../../store/gameStore';
import { useUiStore } from '../../../store/uiStore';

export function FarmPanel() {
  const game = useGameStore((state) => state.game);
  const actions = useGameStore((state) => state.actions);
  const selectedCropId = useUiStore((state) => state.selectedCropId);
  const selectCrop = useUiStore((state) => state.selectCrop);
  const showNotice = useUiStore((state) => state.showNotice);
  const warehouseCount = crops.reduce((sum, crop) => sum + (game.inventory[crop.id] ?? 0), 0);
  const canClaimRelief = canClaimStarterSeedRelief(game, crops);

  return (
    <section className="control-panel">
      <div className="panel-heading">
        <h2>选择种子</h2>
        <span>
          仓库 {warehouseCount}/{game.player.warehouseCapacity}
        </span>
      </div>
      <div className="chip-list">
        {crops.map((crop) => {
          const unlocked = crop.unlockLevel <= game.player.level;
          const seeds = game.inventory[`seed_${crop.id}`] ?? 0;
          return (
            <button
              key={crop.id}
              className={selectedCropId === crop.id ? 'chip selected' : 'chip'}
              disabled={!unlocked}
              onClick={() => selectCrop(crop.id)}
            >
              {crop.emoji} {unlocked ? `${crop.name} ×${seeds}` : `Lv.${crop.unlockLevel}`}
            </button>
          );
        })}
      </div>
      <div className="inventory-row">
        {crops
          .filter((crop) => (game.inventory[crop.id] ?? 0) > 0)
          .map((crop) => (
            <button
              key={crop.id}
              data-tutorial-target="farm-sell-crop"
              className="secondary-button"
              onClick={() => {
                const result = actions.sellCrop(crop.id, game.inventory[crop.id] ?? 0);
                if (!result.ok) showNotice(result.message);
              }}
            >
              出售 {crop.emoji}×{game.inventory[crop.id]}（{crop.sellPrice}/个）
            </button>
          ))}
        {canClaimRelief && (
          <button
            className="secondary-button"
            onClick={() => {
              const result = actions.claimStarterSeedRelief();
              if (!result.ok) showNotice(result.message);
            }}
          >
            🛟 领取 3 颗应急萝卜种子
          </button>
        )}
        <button
          className="secondary-button"
          onClick={() => {
            const result = actions.unlockNextPlot();
            showNotice(result.ok ? '解锁了一块新农田。' : result.message);
          }}
        >
          扩建农田
        </button>
      </div>
      <p className="hint">点击空地播种；作物成熟后点击或按住滑过农田即可收获。</p>
    </section>
  );
}
